module.exports = __webpack_public_path__ + "img/retired-2015-langyashan.d65afca4.jpg";